import * as ActionTypes from '../ActionTypes';

// Sub Module
export const GetSubModule = () => {
    return {
        type: ActionTypes.SUB_MODULE_GET_REQUEST,
    }
}